import { render, staticRenderFns } from "./TextUserEntry.vue?vue&type=template&id=bc94115a&scoped=true&"
import script from "./TextUserEntry.vue?vue&type=script&lang=js&"
export * from "./TextUserEntry.vue?vue&type=script&lang=js&"
import style0 from "./TextUserEntry.vue?vue&type=style&index=0&id=bc94115a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc94115a",
  null
  
)

export default component.exports